import { CSSProperties, Dispatch, useEffect } from "react";
import { Marker, Popup, useMap } from "react-leaflet";
import Leaflet from "leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import { IStore } from "../../../services/api/Store/types";
import { MapCard } from "../MapHoverCard";
import calculateDistanceBetweenCoordinates from "../../../utils/calculateDistanceBetweenCoordinates";
import MapWrapper from "../MapWrapper";

interface MapProps {
  stores: IStore[];
  userCoordinates: [number, number];
  mapCenter: [number, number];
  setMap: Dispatch<any>;
}

const NearbyStoresMap = (props: MapProps) => {
  const { mapCenter, userCoordinates, stores } = props;

  return (
    <MapWrapper
      mapCenter={mapCenter}
      styles={styles.map}
      userCoordinates={userCoordinates}
    >
      <MarkerClusterGroup chunkedLoading>
        {stores.map((store: IStore) => (
          <StoreMarker
            key={store.id}
          store={store}
            userCoordinates={userCoordinates}
              />
          ))}
        </MarkerClusterGroup>
        <MapCenterHandler mapCenter={mapCenter} />
      </MapWrapper>
  );
};

interface StoreMarkerProps {
  store: IStore;
  userCoordinates: [number, number];
}

const StoreMarker = ({ store, userCoordinates }: StoreMarkerProps) => {
  const imageUrl = store.images?.[0]?.imageUrl ?? "";

  return (
      <Marker position={[store.lat, store.lng]} title={store.name}>
        <Popup>
          <MapCard
              imageUrl={imageUrl}
              primaryText={`${store.name}`}
              secondaryText={`${store.district}, ${
                  store.city
              } (${calculateDistanceBetweenCoordinates(
                  store.lat,
                  store.lng,
                  userCoordinates[0],
                  userCoordinates[1]
              ).toFixed(2)} km)`}
              selectedStore={store}
          />
        </Popup>
      </Marker>
  );
};

export default NearbyStoresMap;

const styles = {
  map: {
    height: "90vh",
    zIndex: 0,
  } as CSSProperties,
};

export const MapCenterHandler = (props) => {
  const { mapCenter } = props;
  const map = useMap();

  useEffect(() => {
    if (mapCenter)
      map.setView(Leaflet.latLng(mapCenter[0], mapCenter[1]), map.getZoom(), {
        animate: true,
      });
  }, [mapCenter]);

  return null;
};
